import { Capacitor } from '@capacitor/core'

export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform()
}

export async function pickNativeImage(source: 'camera' | 'gallery'): Promise<File> {
  const { Camera, CameraResultType, CameraSource } = await import('@capacitor/camera')
  const photo = await Camera.getPhoto({
    quality: 85,
    resultType: CameraResultType.Uri,
    source: source === 'camera' ? CameraSource.Camera : CameraSource.Photos,
    correctOrientation: true,
    saveToGallery: false,
  })
  if (!photo.webPath) throw new Error('Камера не повернула файл')
  const response = await fetch(photo.webPath)
  if (!response.ok) throw new Error('Не вдалося прочитати фото')
  const blob = await response.blob()
  const ext = photo.format || 'jpeg'
  return new File([blob], `screen-${Date.now()}.${ext}`, { type: blob.type || `image/${ext}` })
}

export async function initNativeChrome(): Promise<void> {
  if (!isNativeApp()) return
  const [{ StatusBar, Style }, { SplashScreen }, { Keyboard, KeyboardResize }] = await Promise.all([
    import('@capacitor/status-bar'),
    import('@capacitor/splash-screen'),
    import('@capacitor/keyboard'),
  ])
  try {
    await StatusBar.setStyle({ style: Style.Dark })
    await StatusBar.setBackgroundColor({ color: '#0f1115' })
  } catch {
    // iOS інколи не дає backgroundColor
  }
  try {
    await Keyboard.setResizeMode({ mode: KeyboardResize.Body })
  } catch {
    // немає на вебі
  }
  await SplashScreen.hide()
}
